import Glide from '@glidejs/glide';

import { IGetNewsSlidesArray } from './types';
import { NewsPreviewProps } from '../NewsPreview';


const GAP = 8;
const SLIDE_WIDTH = 400;
const SLIDE_WIDTH_MOBILE = 328;

export const getPerView = (
    containerWidth?: number,
    isMobile?: boolean,
): { count: number, overflow: number } => {
    if (containerWidth) {
        const slideSize = isMobile ? SLIDE_WIDTH_MOBILE : SLIDE_WIDTH;
        const count = containerWidth / (slideSize + GAP);
        const countFullSlides = Math.floor(count);

        return {
            count: Math.max(1, countFullSlides),
            overflow: (slideSize + GAP) * (count - countFullSlides),
        };
    }
    return {
        count: 1,
        overflow: 0,
    };
};

export const newsGlider = new Glide('#newsGlide', {
    type: 'slider',
    focusAt: 0,
    bound: true,
    gap: GAP,
    perView: 1,
});

export const getNewsSlidesArray = ({
    elements,
    rowCount,
    colCount,
}: IGetNewsSlidesArray): NewsPreviewProps[][] => {
    const slides = [];
    const slidesCount = Math.max(Math.ceil(Math.ceil(
        elements.length / colCount,
    ) / rowCount) * colCount, colCount);

    for (let slideIndex = 0; slideIndex < slidesCount; slideIndex++) {
        const slide = [];
        const currentElementIndex = slideIndex + Math.floor(
            slideIndex / colCount,
        ) * colCount * (rowCount - 1);
        for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
            const pickElementIndex = currentElementIndex + colCount * rowIndex;
            if (pickElementIndex < elements.length)
                slide.push(elements[pickElementIndex]);
        }
        slides.push(slide);
    }
    return slides;
};
